import React from 'react';
import { shape, string, bool, number, arrayOf, oneOfType, func } from 'prop-types';

export default function TabsSection({ tabs, selectTab, currentTab }) {
    return (
        <div data-tab-content-id={currentTab} className="c-tabs tab-heading-wrapper">
            <div className="tabs-heading">
                <ul>
                    <li data-id="0" className={`tab ${currentTab === 0 ? 'active' : ''}`}>
                        <button onClick={() => selectTab(0)}>
                            <strong>all results</strong>
                        </button>
                    </li>
                    {tabs[0].values.map((value, i) => (
                        <li
                            key={value}
                            data-id={i + 1}
                            className={`tab ${currentTab === i + 1 ? 'active' : ''}`}
                        >
                            <button onClick={() => selectTab(i + 1)}>
                                <strong>{value}</strong>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

TabsSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    tabs: arrayOf(shape({
        code: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number]))
    })).isRequired,
    selectTab: func.isRequired,
    currentTab: number.isRequired
    /* eslint-enable react/no-typos */
};
